module.exports = __webpack_public_path__ + "img/mongolia.ce2d7030.svg";